import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';
@Component({
  selector: 'paypal-errors-dialog',
  template: `
  <md-toolbar color="primary">
  <span>Payment Unsuccessful</span>
  <span class="demo-fill-remaining"></span>
  <span>
    <a>
      <md-icon svgIcon="ic_close_24px.svg" (click)="dialogRef.close()" mdTooltip="{{ 'CLOSE' | tooltip }} " mdTooltipPosition="above"> </md-icon>
    </a>
  </span>
</md-toolbar>
<div fxLayout="column" fxLayout.gt-md="row"  class="modal-content" >
<br>
  <div *ngIf='errors && errors.length'>
    Following error(s) occured while processing your payment.
    <ul>
      <li *ngFor='let error of errors'>
        {{ error.LongMessage }}
      </li>
    </ul>
  </div>
 </div>`
})
export class PaypalErrorsComponent {
  public errors = [];
  constructor(public dialogRef: MdDialogRef<any>) { }
}


// WEBPACK FOOTER //
// ./src/app/paypal-errors.component.ts